import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=021b0295&"
import script from "./Push.vue?vue&type=script&lang=js&"
export * from "./Push.vue?vue&type=script&lang=js&"
import style0 from "./Push.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports